import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer'
import SiteService from './SitesService'

const objectType = 'trap-sites';

class TrapSitesService extends BaseService {

  static getList(page) {

    return super.get(`trap_sites?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }

  static siteSearch(search) {
    return SiteService.siteSearch(search);
  }

  static search(search, page) {

    return super.get(`trap_sites/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });

  }


  static getDetails(id) {
    return super.get(`trap_sites/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['trap-sites'][object.result['trap-sites'][0]];
        // data.comments = object.entities.comments;
        data.adultSurveillances = object.entities['adult-surveillances'];
        data = camelizeKeys(data);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {
    return super.post(objectType, `trap_sites`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {

    return super.patch(objectType, `trap_sites/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super.delete(`trap_sites/${id}`)
      .then((response) => {
        return Promise.resolve({id});
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static shape(data) {
    return super.post(objectType, `trap_sites/shape`, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static createShapes(data) {
    return super.post(objectType, `trap_sites/shape-bulk`, data)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static getTrapNubmers() {
    return super.get('trap_sites/trap-numbers')
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }


}

export default TrapSitesService;